<template>
  <MenuDrawer
    :open="primaryMenuOpen"
    :org-contact-email="theme().novatedBrand?.support?.email"
    :org-contact-phone="theme().novatedBrand?.support?.phone"
    :routes="navigationRoutes"
    :logged-out="!$auth.isAuthenticated"
    :block-create-quote="!canCreateQuote"
    @update:open="setState(['primaryMenuOpen', $event])"
    @create:quote="createQuote"
  />
</template>

<script>
import { mapMutations, mapState, mapGetters } from 'vuex';
import { getEnv } from 'ecx.saigon.ui.common';
import getUserPermissions from '@/utils/user-permissions';
import { profileCompleteGuard } from '@/utils/profile-complete-guard';

export default {
  name: 'MenuDrawerWidget',
  computed: {
    ...mapState({
      user: (state) => state.user.user,
      primaryMenuOpen: (state) => state.ui.primaryMenuOpen,
      application: (state) => state.application.application,
      applicationLoading: (state) => state.application.applicationLoading,
      loadingUser: (state) => state.user.loadingUser,
      hasLeases: (state) => state.lease.hasLeases
    }),
    navigationRoutes() {
      let routes = [
        {
          to: { name: this.$RouteNames.dashboard },
          label: 'Dashboard'
        }
      ];

      if (this.hasLeases) {
        routes = routes.concat(this.$Constants.IN_LIFE_TABS);
      }

      if (getUserPermissions()[this.$Constants.PERMISSIONS.HR_APPROVAL]) {
        routes.push({
          to: { name: this.$RouteNames.hrApprovals },
          label: 'Requests'
        });
      }

      return routes;
    },
    ...mapGetters(['canCreateQuote']),
    ...mapGetters('user', ['theme']),
    ...mapGetters('application', ['acceptedQuoteId'])
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.setState(['primaryMenuOpen', false]);
      }
    }
  },
  methods: {
    ...mapMutations('ui', ['setState']),
    closeMenu() {
      this.setState(['primaryMenuOpen', false]);
    },
    async createQuote() {
      const env = await getEnv();
      if (profileCompleteGuard(this)) {
        return (window.location = env.VUE_APP_QUOTE_ROUTE);
      }
    }
  },
  components: {
    MenuDrawer: () => import('../../components/organism/menu-drawer')
  }
};
</script>
